import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Route, Router, RouterStateSnapshot, UrlSegment, UrlTree } from '@angular/router';
import { UserService } from 'app/core/user/user.service';
import { Observable, of } from 'rxjs';
import { switchMap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class EmbarcadorGeneralGuard {

  constructor(
    private _userService: UserService,
    private _router: Router
  ){}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<any> | Promise<any> | boolean | UrlTree | any
    {
      const redirectUrl = state.url === '/sign-out' ? '/' : state.url;
      this._userService.recoveryUserSession();
      return this._userService.user$
      .pipe(
        switchMap((res: any) => {
          if (res) {
            const userType = res.client != undefined? res.client.type : res.company.clientType;
            if (['EMBARCADOR','FACTORY','INDUSTRY','JODAX','SHIPPER'].includes(userType)) {
              const rolePermission = res.role_id || res.roles;
              if (typeof rolePermission === 'object') {
                if(rolePermission.includes('premix_rastreabilidade_access')) {
                  return of(true);
                } else if (rolePermission.includes('pickingup_apk_access')) {
                  this._router.navigate(['order-operation', 'grid']);
                  return of(false);
                } else {
                  return of(false);
                }
              } else {
                if (rolePermission !== 2 && rolePermission !== 1 && rolePermission !== 22) {
                  this._router.navigate(['order-operation', 'grid']);
                  return of(false);
                }
                return of(true);
              }
            } else {
              return of(false);
            }
          } else {
            this._router.navigate(['sign-in'], {queryParams: {redirectUrl}});
          }
        })
      );
  }
  canActivateChild(
    childRoute: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return true;
  }
  canDeactivate(
    component: unknown,
    currentRoute: ActivatedRouteSnapshot,
    currentState: RouterStateSnapshot,
    nextState?: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return true;
  }
  canLoad(
    route: Route,
    segments: UrlSegment[]): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return true;
  }
}
